import { assign, createMachine, interpret } from 'xstate';
import {
    PHEngState,
    HeartEng2aState,
    HeartEng2bState,
    FinalChoiceState,
    Text
} from "../texts/pancreas-heart"
import Actor from "../characters/Actor";
import Newbie from "../characters/Newbie";
import Foreman from "../characters/Foreman";
import Engineer from "../characters/Engineer";
import { StateContext } from './StateContext';
import { StateEvent } from './StateEvent';
import BaseState from "./BaseState";

export default class HeartPancreasState extends BaseState {
    newbie: Newbie;
    foreman: Foreman;
    eng1: Engineer;
    eng2: Engineer;

    constructor(newbie: Newbie, foreman: Foreman, eng1: Engineer, eng2: Engineer) {
        super();
        this.newbie = newbie;
        this.foreman = foreman;
        this.eng1 = eng1;
        this.eng2 = eng2;

        this.stateMachine = createMachine<StateContext, StateEvent>({
            id: "speech",
            initial: "PH0", //get from state later
            context: {
                actor: undefined
            },
            states: {
                PH0: {
                    on: {
                        SPEAK: {
                            target: "PH1",
                            actions: [
                                assign({
                                    actor: (context, event) => this.foreman
                                })
                            ]
                        },
                        SPEAK_ENG1: {
                            target: "PH7a1",
                            actions: [
                                assign({
                                    actor: (context, event) => this.eng1
                                })
                            ]
                        },
                        SPEAK_ENG2: {
                            target: "PH7a1",
                            actions: [
                                assign({
                                    actor: (context, event) => this.eng1
                                })
                            ]
                        },
                        SPEAK_FINISH: {
                            target: "PH7c1",
                            actions: [
                                assign({
                                    actor: (context, event) => this.foreman
                                })
                            ]
                        },
                        SPEAK_HAPPY: {
                            target: "PHCOMM",
                            actions: [
                                assign({
                                    actor: (context, event) => this.eng1
                                })
                            ]
                        }
                    }
                },
                PHCOMM: {
                    on: {
                        SPEAK: {
                            target: "PHCOMM0",
                            actions: [
                                (context) => {
                                    this.eng1.removeSpeechBubble();
                                    this.eng1.playHappyAnimation();

                                    this.onConversationEndHandler?.();
                                },
                            ],
                        }
                    }
                },
                PHCOMM0: {
                    on: {
                        SPEAK: {
                            target: "PHCOMM",
                            actions: [
                                (context) => {
                                    this.eng1.removeSpeechBubble();
                                    this.eng1.playHappyAnimation();
                                },
                            ],
                        }
                    }
                },
                PH1: {
                    on: {
                        SPEAK: {
                            target: "PH2",
                            actions: [
                                (context) => this.foreman.removeSpeechBubble(),
                                assign({
                                    actor: (context, event) => this.newbie
                                }),
                            ],
                        }
                    }
                },
                PH2: {
                    on: {
                        SPEAK: [{
                            target: "PH3",
                            actions: [
                                (context) => this.newbie.removeSpeechBubble(),
                                assign({
                                    actor: (context, event) => this.eng1
                                }),
                            ],
                        }]
                    }

                }, PH3: {
                    on: {
                        SPEAK: [{
                            target: "PH4",
                            actions: [
                                (context) => this.eng1.removeSpeechBubble(),
                                assign({
                                    actor: (context, event) => this.newbie
                                }),
                            ],
                        }]
                    }

                },
                PH4: {
                    on: {
                        SPEAK: {
                            target: "PH5",
                            actions: [
                                (context) => this.newbie.removeSpeechBubble(),
                                assign({
                                    actor: (context, event) => this.eng1
                                })
                            ]
                        }
                    }
                },
                PH5: {
                    on: {
                        SPEAK: {
                            target: "PH6a1",
                            actions: [
                                (context) => this.eng1.removeSpeechBubble(),
                                assign({
                                    actor: (context, event) => this.eng2
                                })
                            ]
                        }
                    }
                },
                PH6a1: {
                    on: {
                        SPEAK: [{
                            target: "PH6a2",
                            actions: [assign({
                                actor: (context, event) => this.newbie
                            }), (context, event, actionMeta) => {
                                this.newbie.removeSpeechBubble();
                                this.eng2.removeSpeechBubble();
                                this.sayFromChoices(HeartEng2aState, Text, 'PH6a2', actionMeta, this.newbie, this.eng2);
                            }]
                        }]
                    }
                },
                PH6a2: {
                    exit: (context, event, actionMeta) => {
                        this.saveChoice(actionMeta, newbie);
                    },
                    on: {
                        SPEAK: [{
                            target: "PH6a3a",
                            actions: [
                                assign({
                                    actor: (context, event) => this.eng2
                                }),
                                (context, event) => {
                                    this.newbie.removeSpeechBubble();
                                }],
                            cond: (context: StateContext, event: StateEvent) => {
                                return this.newbie.lastChoice === 0;
                            }
                        },
                        {
                            target: "PH6a3b",
                            actions: [
                                assign({
                                    actor: (context, event) => this.eng2
                                }),
                                (context, event) => {
                                    this.newbie.removeSpeechBubble();
                                }],
                            cond: (context: StateContext, event: StateEvent) => {
                                return this.newbie.lastChoice === 1;
                            }
                        }]
                    }
                },
                PH6a3a: {
                    on: {
                        SPEAK: {
                            target: "PH0",
                            actions: [
                                assign({
                                    actor: (context, event) => this.eng2
                                }),
                                (context, event) => {
                                    this.eng2.removeSpeechBubble();

                                    this.onConversationEndHandler?.();
                                }],
                        }
                    }
                },
                PH6a3b: {
                    on: {
                        SPEAK: {
                            target: "PH0",
                            actions: [
                                assign({
                                    actor: (context, event) => this.eng2
                                }),
                                (context, event) => {
                                    this.eng2.removeSpeechBubble();

                                    this.onConversationEndHandler?.();
                                }],
                        }
                    }
                },
                PH7a1: {
                    on: {
                        SPEAK: {
                            target: "PH7a2",
                            actions: [assign({
                                actor: (context, event) => this.newbie
                            }), (context, event, actionMeta) => {
                                this.newbie.removeSpeechBubble();
                                this.eng1.removeSpeechBubble();
                                this.sayFromChoices(PHEngState, Text, 'PH7a2', actionMeta, this.newbie, this.eng1);
                            }]
                        }
                    }
                },
                PH7a2: {
                    exit: (context, event, actionMeta) => {
                        this.saveChoice(actionMeta, newbie);
                    },
                    on: {
                        SPEAK: [{
                            target: "PH7a3a",
                            actions: [
                                assign({
                                    actor: (context, event) => this.eng1
                                }),
                                (context, event) => {
                                    this.newbie.removeSpeechBubble();
                                }],
                            cond: (context: StateContext, event: StateEvent) => {
                                return this.newbie.lastChoice === 0;
                            }

                        }, {
                            target: "PH7a3b",
                            actions: [
                                assign({
                                    actor: (context, event) => this.eng1
                                }),
                                (context, event) => {
                                    this.newbie.removeSpeechBubble();
                                }],
                            cond: (context: StateContext, event: StateEvent) => {
                                return this.newbie.lastChoice === 1;
                            }

                        }]

                    }
                },
                PH7a3a: {
                    on: {
                        SPEAK: {
                            target: "PH7a4a",
                            actions: [
                                assign({
                                    actor: (context, event) => this.newbie
                                }),
                                (context, event) => {
                                    this.eng1.removeSpeechBubble();
                                }],
                        }
                    }
                },
                PH7a3b: {
                    on: {
                        SPEAK: {
                            target: "PH7a4a",
                            actions: [
                                assign({
                                    actor: (context, event) => this.newbie
                                }),
                                (context, event) => {
                                    this.eng1.removeSpeechBubble();
                                }],
                        }
                    }
                },
                PH7a4a: {
                    on: {
                        SPEAK: [{
                            target: "PH7a5a",
                            actions: [
                                assign({
                                    actor: (context, event) => this.eng1
                                }),
                                (context, event) => {
                                    this.newbie.removeSpeechBubble();
                                }],

                        }]
                    }
                },
                PH7a5a: {
                    on: {
                        SPEAK: [{
                            target: "PH7b1",
                            actions: [
                                assign({
                                    actor: (context, event) => this.eng2
                                }),
                                (context, event) => {
                                    this.eng1.removeSpeechBubble();
                                }],

                        }]
                    }
                },
                PH7b1: {
                    on: {
                        SPEAK: [{
                            target: "PH7b2",
                            actions: [
                                assign({
                                    actor: (context, event) => this.eng2
                                }),
                                (context, event, actionMeta) => {
                                    this.newbie.removeSpeechBubble();
                                    this.eng2.removeSpeechBubble();
                                    this.sayFromChoices(HeartEng2bState, Text, 'PH7b2', actionMeta, this.newbie, this.eng2);
                                }]

                        }]
                    }
                },
                PH7b2: {
                    exit: (context, event, actionMeta) => {
                        this.saveChoice(actionMeta, newbie);
                    },
                    on: {
                        SPEAK: [{
                            target: "PH7b3a",
                            actions: [
                                assign({
                                    actor: (context, event) => this.eng2
                                }),
                                (context, event) => {
                                    this.newbie.removeSpeechBubble();
                                }],
                            cond: (context: StateContext, event: StateEvent) => {
                                return this.newbie.lastChoice === 0;
                            }

                        }, {
                            target: "PH7b3b",
                            actions: [
                                assign({
                                    actor: (context, event) => this.eng2
                                }),
                                (context, event) => {
                                    this.newbie.removeSpeechBubble();
                                }],
                            cond: (context: StateContext, event: StateEvent) => {
                                return this.newbie.lastChoice === 1;
                            }

                        }]

                    }
                },
                PH7b3a: {
                    on: {
                        SPEAK: [{
                            target: "PH0",
                            actions: [
                                assign({
                                    actor: (context, event) => this.eng1
                                }),
                                (context, event) => {
                                    this.eng2.removeSpeechBubble();

                                    this.onConversationEndHandler?.();
                                }],

                        }]
                    }
                },
                PH7b3b: {
                    on: {
                        SPEAK: [{
                            target: "PH0",
                            actions: [
                                assign({
                                    actor: (context, event) => this.eng1
                                }),
                                (context, event) => {
                                    this.eng2.removeSpeechBubble();

                                    this.onConversationEndHandler?.();
                                }],

                        }]
                    }
                },
                PH7c1: {
                    on: {
                        SPEAK: {
                            target: "PH7c2",
                            actions: (context, event, actionMeta) => {
                                this.foreman.removeSpeechBubble();
                                this.newbie.removeSpeechBubble();
                                this.sayFromChoices(FinalChoiceState, Text, 'PH7c2', actionMeta, this.newbie);
                            },
                        }
                    }
                },
                PH7c2: {
                    exit: (context, event, actionMeta) => {
                        this.saveChoice(actionMeta, newbie);
                    },
                    on: {
                        SPEAK: [{
                            target: "PH0",
                            actions: (context, event) => {
                                this.foreman.removeSpeechBubble();
                                this.newbie.removeSpeechBubble();

                                this.onFinishHandler?.();
                            },
                            cond: (context: StateContext, event: StateEvent) => {
                                return this.newbie.lastChoice === 0;
                            }

                        },
                        {
                            target: "PH0",
                            cond: (context: StateContext, event: StateEvent) => {
                                this.foreman.removeSpeechBubble();
                                this.newbie.removeSpeechBubble();

                                return this.newbie.lastChoice === 1;
                            }

                        }]
                    }
                }

            },
        });

        this.set();
    }

    set(): void {
        this.service = interpret(this.stateMachine).onTransition(
            (state, event) => {
                const actor = state.context.actor as Actor;
                const value = state.value as string;

                if (actor && Object.keys(Text).includes(value)) {
                    const text: string = (<any>Text)[value];
                    actor.say([text]);
                }
            }
        ).start();
    }
}